import apiClient from '../axiosClient';
import Field from '../interfaces/field';
import { dispatch } from '../store/store';
import { loadFields } from '../store/slices/fieldSlice';

class FieldService {
    static async updateFieldsInRedux(): Promise<boolean> {
        try {
            const response = await apiClient.get('/api/v1/field');
            if (response.status === 200) {
                const fields: Field[] = response.data;
                dispatch(loadFields(fields));
                return true;
            } else {
                alert("Error while loading field list. Error: " + response.data.message);
                return false;
            }
        } catch (error: any) {
            if (error.response) {
                alert('Error response data: ' + error.response.data.message);
            } else if (error.request) {
                alert('No response received: ' + error.request);
            } else {
                alert('Error message: ' + error.message);
            }
            return false;
        }
    }
}

export default FieldService;
